export const clearLocalStorage = () => {
  localStorage.clear();
  console.log("Local storage cleared.");
};

export const goToLandingPage = (url = "/dashboard") => {
  window.location.href = url;
};
